import appRoutes from '../../infrastructure/constants/appRoutes';
import history from '../../infrastructure/helpers/react/history';
import identityProvider from '../../infrastructure/authorization/identityProvider';
import React from 'react';

class LoginComplete extends React.Component {

    constructor(props: any) {
        super(props);

        identityProvider.loginComplete().then(() => history.replace(appRoutes.home));
    }

    render(): string {
        return 'Authenticating...';
    }
}

export default LoginComplete;
